import React, {useState} from 'react'

import Paper from '@material-ui/core/Paper'
import Box from '@material-ui/core/Box'
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';

import MDEditor from '@uiw/react-md-editor';


function TasksBox() {

  const [value, setValue] = useState( `
# Hello world!!!

This is our tasks document.

These are the tasks we want to complete:
* Do this (worth ~20 shares)
* Do that (worth ~15 shares)
* Do everything (worth ~100 shares)

Once these are done, we will evaluate new features.
`);
  const [editingValue, setEditingValue] = useState(value);

  const [editing, setEditing] = useState(false)

  const handleSubmit = () => {
    setValue(editingValue)
    setEditing(false)
  }

  return (
    <div>
      <Paper>
        <Box align="right">
          <IconButton onClick={() => setEditing(!editing)}><EditIcon/></IconButton>
        </Box>

        <Box align="left"  paddingX={5} paddingTop={0} paddingBottom={2} hidden={!editing}>
          <Box paddingBottom={2}>
          <MDEditor value={editingValue} onChange={setEditingValue} height={500}/>
          </Box>
          <Box align="right">
            <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
          </Box>
        </Box>

        <Box align="left"  paddingX={10} paddingTop={0} paddingBottom={5} hidden={editing}>
          <br/>
            <MDEditor.Markdown source={value} />
          <br/>
        </Box>

      </Paper>

    </div>
  )
}

export default TasksBox
